import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import '../styles/style.css'
import SocialMediaBtns from "../components/socialMediaBtns"

const IndexPage = () => {

  return <>
  <Layout>
    <SEO title="F22 Labs" />
    <div className="landing">
      <h2 className="title">HeyHey <span>❤</span> F22 Labs</h2>
      
      <div className="video-box">
        <iframe 
        title='You Tube' 
        className="video" 
        src="https://www.youtube.com/embed/RjARS-aZd_8" 
        frameBorder="0" 
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen>
        </iframe>
      </div>
      
      <p className="description">
        You're looking at the worlds first of its type, interactive dine-in table for
        pizzeria, cafes, bars, and lounges. The touch table can take
        order/customise food, pay and play games on it.
      </p>

      <SocialMediaBtns title='title' url='http://f22labs.com/' text='Check out this website :' />
      
      <a href="/" className="help">Start your project with us</a>

    </div> 
  </Layout>
  </>
}

export default IndexPage
